import { render, staticRenderFns } from "./LatestNewsCard.vue?vue&type=template&id=4bc82113&scoped=true"
import script from "./LatestNewsCard.vue?vue&type=script&lang=ts"
export * from "./LatestNewsCard.vue?vue&type=script&lang=ts"
import style0 from "./LatestNewsCard.vue?vue&type=style&index=0&id=4bc82113&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc82113",
  null
  
)

export default component.exports